import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';

import {updateAgreementUser} from 'ducks/agreementUsers';
import {selectCountries} from 'ducks/countries';
import {required, validBirthDate} from 'utils/validators';
import {formatDate, formatDateForApi} from 'utils/datetime';
import Label from 'components/Label';
import FormField from 'components/FormField';
import ErrorBlock from 'components/ErrorBlock';
import {
  TextField,
  EmailField,
  DateField,
  SearchCountryField,
  GenderField
} from 'components/Fields';
import {getGenderFieldValue} from 'components/Fields/Gender';

import './styles.css';

const getValueOrEmptyString = value => value || '';

const onSubmit = (values, dispatch, props) => {
  const {agreementUserId, agreementUser} = props;
  const {fullName, phone, gender, dateOfBirth, nationality, email} = values;

  const extraActions = props.getExtraActions();
  const data = {
    fullName: getValueOrEmptyString(fullName),
    phone: getValueOrEmptyString(phone),
    gender: getGenderFieldValue(gender),
    nationality: getValueOrEmptyString(_.get(nationality, 'value')),
    birthday: formatDateForApi(dateOfBirth),
    location: props.locationRef,
    agreementUserId
  };

  if (!agreementUser.isAdmin) {
    data['email'] = getValueOrEmptyString(email);
  }

  dispatch(updateAgreementUser(data, extraActions));
};

const AgreementUserEditForm = ({
  error,
  isInEditMode,
  countries,
  agreementUser
}) => {
  const emptyPlaceholder = isInEditMode ? null : '';

  return (
    <form className="AgreementUserEditForm">
      {error && <ErrorBlock>{error}</ErrorBlock>}
      <FormField>
        <Label>full name</Label>
        <Field name="fullName" component={TextField} disabled={!isInEditMode} />
      </FormField>

      <FormField>
        <Label>email</Label>
        <Field
          name="email"
          validate={[required]}
          component={EmailField}
          disabled={!isInEditMode || agreementUser.isAdmin}
        />
      </FormField>

      <FormField>
        <Label>phone</Label>
        <Field name="phone" component={TextField} disabled={!isInEditMode} />
      </FormField>

      <FormField>
        <Label>gender</Label>
        <Field name="gender" component={GenderField} disabled={!isInEditMode} />
      </FormField>

      <FormField>
        <Label>date of birth</Label>
        <Field
          name="dateOfBirth"
          validate={[validBirthDate]}
          component={DateField}
          disabled={!isInEditMode}
          placeholder={emptyPlaceholder}
        />
      </FormField>

      <FormField>
        <Label>nationality</Label>
        <SearchCountryField
          disabled={!isInEditMode}
          countries={countries}
          placeholder={emptyPlaceholder}
          name="nationality"
        />
      </FormField>
    </form>
  );
};

const mapStateToProps = (state, props) => {
  const countries = selectCountries(state);
  const {agreementUser} = props;
  let {dateOfBirth} = agreementUser;
  dateOfBirth = dateOfBirth ? formatDate(dateOfBirth) : dateOfBirth;

  return {
    initialValues: {
      fullName: agreementUser.fullName,
      email: agreementUser.email,
      phone: agreementUser.phone,
      gender: agreementUser.gender,
      dateOfBirth,
      nationality: {
        value: agreementUser.nationality.code,
        label: agreementUser.nationality.name
      }
    },
    agreementUserId: agreementUser.id,
    countries
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'agreementUserEdit',
    enableReinitialize: true,
    onSubmit
  })(AgreementUserEditForm)
);
